// Мета-данные для поисковых роботов и соцсетей (OpenGraph, Twitter, canonical, JSON-LD).
// Модуль без зависимостей: его подключает и сайт (обновление тегов при переходах), и скрипт сборки scripts/seo.js
// (готовые HTML-страницы для роботов, которые не выполняют JavaScript: Telegram, VK, WhatsApp и др.).

export const GEO = {
  abaata: { lat: 43.325107, lng: 40.223833 },
  pitsunda: { lat: 43.182704, lng: 40.287957 },
  amari: { lat: 43.283169, lng: 40.262681 }
}

// Тексты главных страниц. Название отеля в заголовках внутренних страниц: LABEL.
export const COPY = {
  abaata: {
    label: 'Отель Абаата, Гагра',
    title: 'Отель Абаата в Гагре — исторический курорт у моря',
    description: 'Исторический курорт у моря на территории Гагрской крепости в Абхазии: номера, рестораны, SPA, пляж и бассейн. Бронирование без посредников на официальном сайте.'
  },
  pitsunda: {
    label: 'Абаата Пицунда',
    title: 'Абаата Пицунда — новый отель у моря',
    description: 'Новый отель у моря в Пицунде, в окружении природного ландшафта: номера, SPA, ресторан, детская зона и бассейн. Бронирование на официальном сайте.'
  },
  amari: {
    label: 'Amari Hotel',
    title: 'Amari Hotel — бутик-отель класса делюкс в Гагре',
    description: 'Новый современный бутик-отель класса делюкс на первой береговой линии в Гагре: номера, SPA, открытый бассейн, ресторан и Roof bar. Бронирование на официальном сайте.'
  },
  select: {
    label: 'Абаата',
    title: 'Абаата и Amari — отели в Гагре и Пицунде',
    description: 'Выберите отель: исторический курорт Абаата в Гагре, новый отель Абаата Пицунда или бутик-отель Amari в Гагре. Номера, рестораны, SPA и бронирование на официальном сайте.'
  }
}

// Названия страниц по имени маршрута
export const PAGES = {
  About: 'О комплексе',
  Awards: 'Награды',
  Gallerys: 'Галерея',
  webcam: 'Веб-камеры',
  Offers: 'Размещение и номера',
  restaurants: 'Рестораны и бары',
  services: 'Развлечения и услуги',
  spa: 'SPA',
  contacts: 'Контакты',
  price: 'Цены',
  booking: 'Бронирование',
  feedback: 'Обратная связь',
  blog: 'Блог',
  Afisha: 'Афиша',
  Specoffers: 'Специальные предложения',
  important: 'Важная информация',
  docs: 'Документы',
  orderTransfer: 'Заказ трансфера',
  'hair-clinic': 'Клиника восстановления волос'
}

// Страницы, которые не должны попадать в поиск: формы и служебные экраны
export const NOINDEX_ROUTES = ['booking', 'menu', 'orderTransfer']

export const siteKey = (site) => (site === 'picunda' ? 'pitsunda' : site)

/** Адрес страницы на сайте. Amari на своём домене живёт без префикса /amari/. Для каталогов добавляется «/» в конце. */
export function publicPath (site, path, amariMode) {
  const p = ('/' + String(path || '').replace(/^\/+/, '')).replace(/\/{2,}/g, '/')
  const full = amariMode && siteKey(site) === 'amari' ? p : '/' + siteKey(site) + (p === '/' ? '/' : p)
  const clean = full.split('#')[0].split('?')[0]
  return clean.endsWith('/') || /\.[a-z0-9]{2,5}$/i.test(clean) ? clean : clean + '/'
}

const stripTags = (html) => String(html || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/&[a-z]+;/gi, ' ').replace(/\s+/g, ' ').trim()

/** Первые ~160 знаков текста без тегов, обрезанные по слову */
export function snippet (html, max = 160) {
  const t = stripTags(html)
  if (t.length <= max) return t
  const cut = t.slice(0, max)
  return cut.slice(0, Math.max(cut.lastIndexOf(' '), 60)).replace(/[,.;:\s—-]+$/, '') + '…'
}

/**
 * Заголовок, описание и картинка страницы.
 * page: { name, description, image, routeName, home }. Для главной страницы отеля берутся тексты из COPY.
 */
export function pageMeta ({ site, page = {}, select = false }) {
  const key = select ? 'select' : siteKey(site)
  const copy = COPY[key]
  const name = page.name || PAGES[page.routeName] || ''
  const home = select || page.home || !name
  const title = home ? copy.title : `${name} — ${copy.label}`
  const description = home ? copy.description : (snippet(page.description) || `${name}: ${copy.label}. ${copy.description}`.slice(0, 200))
  return {
    title,
    description,
    image: page.image || null,
    noindex: !!page.noindex || NOINDEX_ROUTES.includes(page.routeName),
    home
  }
}

const esc = (s) => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

/** Разметка Schema.org Hotel для главной страницы отеля */
export function hotelJsonLd ({ site, info, origin, url, image, description, name }) {
  const key = siteKey(site)
  const geo = GEO[key]
  const data = {
    '@context': 'https://schema.org',
    '@type': 'Hotel',
    name: name || COPY[key].label,
    description,
    url,
    image,
    telephone: info.tel,
    address: { '@type': 'PostalAddress', addressCountry: 'Абхазия', addressLocality: info.place, streetAddress: String(info.address || '').replace(/^Абхазия,\s*[^,]+,\s*/, '') }
  }
  if (info.email) data.email = info.email
  if (geo) data.geo = { '@type': 'GeoCoordinates', latitude: geo.lat, longitude: geo.lng }
  const same = [info.vk, info.instagram, info.facebook, info.telegram].filter(Boolean)
  if (same.length) data.sameAs = same
  return data
}

/**
 * Набор тегов head. origin: https://abaata.ru; path: публичный адрес страницы (/abaata/offers/);
 * meta: результат pageMeta; extra.ldjson: объект для JSON-LD (необязательно).
 * Возвращает массив { tag, attrs, text }.
 */
export function headTags ({ origin, path, meta, siteName, locale = 'ru_RU', defaultImage, noindexAll = false, ldjson }) {
  const url = origin + path
  const image = meta.image ? (/^https?:/.test(meta.image) ? meta.image : origin + meta.image) : origin + defaultImage
  const robots = noindexAll || meta.noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large'
  const T = (tag, attrs, text) => ({ tag, attrs: { ...attrs, 'data-seo': '1' }, text })
  const tags = [
    T('title', {}, meta.title),
    T('meta', { name: 'description', content: meta.description }),
    T('meta', { name: 'robots', content: robots }),
    T('link', { rel: 'canonical', href: url }),
    T('meta', { property: 'og:type', content: 'website' }),
    T('meta', { property: 'og:site_name', content: siteName }),
    T('meta', { property: 'og:locale', content: locale }),
    T('meta', { property: 'og:title', content: meta.title }),
    T('meta', { property: 'og:description', content: meta.description }),
    T('meta', { property: 'og:url', content: url }),
    T('meta', { property: 'og:image', content: image }),
    T('meta', { name: 'twitter:card', content: 'summary_large_image' }),
    T('meta', { name: 'twitter:title', content: meta.title }),
    T('meta', { name: 'twitter:description', content: meta.description }),
    T('meta', { name: 'twitter:image', content: image })
  ]
  if (ldjson) tags.push(T('script', { type: 'application/ld+json' }, JSON.stringify(ldjson)))

  return tags
}

/** Теги в виде HTML-строки для вставки в head готовой страницы */
export function renderTags (tags) {
  return tags.map(({ tag, attrs, text }) => {
    const a = Object.entries(attrs).map(([k, v]) => ` ${k}="${esc(v)}"`).join('')
    if (tag === 'title') return `<title${a}>${esc(text)}</title>`
    if (tag === 'script') return `<script${a}>${String(text).replace(/</g, '\\u003c')}</script>`
    return `<${tag}${a}>`
  }).join('\n    ')
}

// Теги, которыми управляет модуль, помечены атрибутом data-seo (сборка вырезает HTML-комментарии, поэтому маркеров нет)
const MANAGED = /<title[^>]*data-seo[^>]*>[\s\S]*?<\/title>|<script[^>]*data-seo[^>]*>[\s\S]*?<\/script>|<(?:meta|link)[^>]*data-seo[^>]*>/gi

/** Убирает прежние управляемые теги и вставляет новые перед </head> */
export function injectIntoHtml (html, tags) {
  if (!/<\/head>/i.test(html)) throw new Error('В index.html нет </head>')
  return html.replace(MANAGED, '').replace(/<\/head>/i, renderTags(tags) + '</head>')
}
